export enum XferAction {
  REQUEST,
  ACCEPT,
  REJECT,
  CANCEL,
  STEAL,
  FORCE_STEAL,
}

export namespace XferAction {
  let elements = [
    XferAction.REQUEST,
    XferAction.ACCEPT,
    XferAction.REJECT,
    XferAction.CANCEL,
    XferAction.STEAL,
    XferAction.FORCE_STEAL,
  ];
  let alias = "com.bcdfx.api.servicerequest.trading.XferAction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
